// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__POFds","time":"styles_time__106QX"};